import { Accordion as ChakraAccordion, AccordionProps as ChakraAccordionProps } from '@chakra-ui/react';

export type AccordionProps = Omit<ChakraAccordionProps, 'as'>;

const Accordion = ({ ...props }: AccordionProps) => <ChakraAccordion {...props} />;

export { Accordion };
